import { createClient } from '@supabase/supabase-js'

// React יודע למשוך את הערכים מהקובץ .env באמצעות process.env
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey)